
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Contact } from '../../../backend/backendapi';
import { isValidPhone, phonePlaceholder } from './phone';

@Component
export default class TabDetails extends Vue {
  @Prop({ default: false })
  readonly contact!: Contact;

  isValidPhone = isValidPhone;
  phonePlaceholder = phonePlaceholder;

  get uid(): string {
    return (this as any)._uid;
  }
}
